import { useMemo } from 'react';

import { IResponsiveClassNames } from '../../../shared/types/IResponsiveClassNames';
import { SCREEN_SIZES } from '../../../shared/types/SCREEN_SIZES';

import { IGridVisibilityProps } from './IGridVisibilityProps';

enum GRID_CELL_VISIBILITY {
    HIDDEN,
    VISIBLE,
}

const responsiveVisibilityClassNames: IResponsiveClassNames<GRID_CELL_VISIBILITY> = {
    [SCREEN_SIZES.SMALL]: {
        [GRID_CELL_VISIBILITY.HIDDEN]: 'hidden',
        [GRID_CELL_VISIBILITY.VISIBLE]: 'block',
    },
    [SCREEN_SIZES.MEDIUM]: {
        [GRID_CELL_VISIBILITY.HIDDEN]: 'md:hidden',
        [GRID_CELL_VISIBILITY.VISIBLE]: 'md:block',
    },
    [SCREEN_SIZES.LARGE]: {
        [GRID_CELL_VISIBILITY.HIDDEN]: 'lg:hidden',
        [GRID_CELL_VISIBILITY.VISIBLE]: 'lg:block',
    },
};

function getVisibility (flag: boolean | undefined, visibility: GRID_CELL_VISIBILITY): GRID_CELL_VISIBILITY | undefined {
    if (flag) {
        return visibility;
    }

    return undefined;
}

function getVisibilityClassName (screen: SCREEN_SIZES, visibility: GRID_CELL_VISIBILITY | undefined): string | undefined {
    if (visibility === undefined) {
        return undefined;
    }

    return responsiveVisibilityClassNames[screen][visibility];
}

export function useVisibilityClassNames (props: IGridVisibilityProps): string {
    const {
        smHide,
        mdHide,
        lgHide,

        smShow,
        mdShow,
        lgShow,
    }: IGridVisibilityProps = props;

    const classes: string = useMemo<string>((): string => {
        return [
            getVisibilityClassName(SCREEN_SIZES.SMALL, getVisibility(smShow, GRID_CELL_VISIBILITY.VISIBLE)),
            getVisibilityClassName(SCREEN_SIZES.MEDIUM, getVisibility(mdShow, GRID_CELL_VISIBILITY.VISIBLE)),
            getVisibilityClassName(SCREEN_SIZES.LARGE, getVisibility(lgShow, GRID_CELL_VISIBILITY.VISIBLE)),

            getVisibilityClassName(SCREEN_SIZES.SMALL, getVisibility(smHide, GRID_CELL_VISIBILITY.HIDDEN)),
            getVisibilityClassName(SCREEN_SIZES.MEDIUM, getVisibility(mdHide, GRID_CELL_VISIBILITY.HIDDEN)),
            getVisibilityClassName(SCREEN_SIZES.LARGE, getVisibility(lgHide, GRID_CELL_VISIBILITY.HIDDEN)),
        ].join(' ');
    }, [
        smHide,
        mdHide,
        lgHide,
        smShow,
        mdShow,
        lgShow,
    ]);

    return classes;
}
